import React, { useEffect, useLayoutEffect, useState } from 'react';
import './question-game.css';
import {
    goBack,
    goToScreen,
    goToScreenAndReset,
    setHistoryScreenState,
} from '../../actions/router';
import { connect } from 'react-redux';
import {
    MAIN_GAME_SCREEN,
    QUESTIONS_GAME_SCREEN,
    QUICKPLAY_SCREEN,
    SETTINGS_SCREEN,
} from '../../constants/routes';
import { completeTutorial } from '../../actions/tutorials';
import {
    progressTime,
    removePhoneCall,
    updateOverallScores,
} from '../../actions/active-game';
import { Panel } from '../../components/panel';
import { IconButton } from '../../components/icon-button';
import { TutorialModalParent } from '../../components/modal-parents/tutorial-modal';
import { ProgressUpdateModalParent } from '../../components/modal-parents/progress-update-modal';
import Copy from '../../copy/questions';
import classNames from 'classnames';
import { Question } from './question';
import { Heading } from '../../components/heading';
import { selectRandomArrayEntry } from '../../helpers/active-game';
import { SpeakerGameScreen } from '../debate-game-screen/speaker-game-screen';

const QuestionsGameScreen = props => {
    const {
        goBack,
        goToSettings,
        continueTo,
        continueRoute,
        historyScreenState,
        tutorialCompleted,
        completeQuestionTutorial,
        previousScores,
        submitOverallScores,
        currentCall,
        removePhoneCallFromCalendar,
        difficulty,
        progressGame,
    } = props;

    const [step, setStep] = useState('question');
    const [currentQuestion, setCurrentQuestion] = useState();

    const [currentGameScores, setCurrentGameScores] = useState({});
    const [progressUpdateVisible, setProgressUpdateVisible] = useState(false);
    const [responseFeedback, setResponseFeedback] = useState(null);

    const modalVisible = progressUpdateVisible || !tutorialCompleted;
    const questions = Copy.questions[difficulty];

    useEffect(() => {
        if (continueRoute === QUICKPLAY_SCREEN) {
            const randomTopic = selectRandomArrayEntry(Object.keys(questions));
            setCurrentQuestion(randomTopic);
        } else {
            setCurrentQuestion(currentCall.taskID);
        }
    }, [continueRoute, currentCall, questions]);

    useLayoutEffect(() => {
        if (historyScreenState.screen === QUESTIONS_GAME_SCREEN) {
            setCurrentQuestion(historyScreenState.state.activeQuestion);
            setStep(historyScreenState.state.step);
        }
    }, [historyScreenState]);

    const submitResponse = optionIndex => {
        const option = questions[currentQuestion].questions[optionIndex];

        const scores = {
            party: option.score_party,
            voters: option.score_local,
            media: option.score_media,
        };

        setCurrentGameScores(scores);
        setResponseFeedback(option.feedback);
        setStep('animation');
    };

    const completeGame = () => {
        if (continueRoute === MAIN_GAME_SCREEN) {
            submitOverallScores(previousScores, currentGameScores);
            removePhoneCallFromCalendar(currentCall.phone_callID);
            progressGame();
        }
        continueTo(continueRoute);
    };

    const questionPageClasses = classNames({
        'question-game': true,
        'question-game--hidden': modalVisible,
    });

    return (
        <>
            {step === 'question' ? (
                <div className={questionPageClasses} aria-hidden={modalVisible}>
                    <IconButton
                        iconName="back"
                        size="small"
                        type="essential"
                        withSpacing={true}
                        onClick={() => {
                            if (continueRoute === MAIN_GAME_SCREEN) {
                                removePhoneCallFromCalendar(
                                    currentCall.phone_callID,
                                );
                            }
                            goBack();
                        }}
                        isDisabled={modalVisible}
                    />
                    <Panel
                        flexDirection="column"
                        withPadding={true}
                        color="purple"
                        currentPage="questions game question"
                    >
                        <div className="question-game__header">
                            <Heading colorScheme="dark" withSpacing={false}>
                                {Copy.heading}
                            </Heading>
                        </div>
                        {currentQuestion && (
                            <Question
                                question={questions[currentQuestion]}
                                submitResponse={submitResponse}
                                modalVisible={modalVisible}
                            />
                        )}
                    </Panel>
                    <IconButton
                        iconName="settings"
                        size="small"
                        type="essential"
                        withSpacing={true}
                        onClick={() => goToSettings(currentQuestion, step)}
                        isDisabled={modalVisible}
                    />
                </div>
            ) : (
                <SpeakerGameScreen
                    goBack={() => setStep('question')}
                    goToSettings={() => goToSettings(currentQuestion, step)}
                    tutorialCompleted={true}
                    accessibleVersion={true}
                    completeSpeakerGame={() => {
                        setProgressUpdateVisible(true);
                    }}
                    questionsGame={true}
                />
            )}
            {!tutorialCompleted && (
                <TutorialModalParent
                    screen="questions"
                    onClick={() => completeQuestionTutorial()}
                />
            )}
            {progressUpdateVisible === true && (
                <ProgressUpdateModalParent
                    previousScores={previousScores}
                    gameScores={currentGameScores}
                    feedback={responseFeedback}
                    onClick={() => completeGame()}
                />
            )}
        </>
    );
};

const mapStateToProps = state => {
    return {
        continueRoute: state.router.history[state.router.history.length - 2],
        historyScreenState: state.router.historyScreenState,
        tutorialCompleted:
            state.activeGame.tutorialsCompleted[QUESTIONS_GAME_SCREEN],
        previousScores: state.activeGame.overallScores,
        currentCall: state.activeGame.currentCall,
        difficulty: state.settings.gameSettings.difficulty,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        goBack: () => {
            dispatch(goBack());
        },
        goToSettings: (activeQuestion, step) => {
            dispatch(
                setHistoryScreenState(QUESTIONS_GAME_SCREEN, {
                    activeQuestion,
                    step,
                }),
            );
            dispatch(goToScreen(SETTINGS_SCREEN));
        },
        continueTo: route => {
            dispatch(goToScreenAndReset(route));
        },
        completeQuestionTutorial: () => {
            dispatch(completeTutorial(QUESTIONS_GAME_SCREEN));
        },
        submitOverallScores: (previousScores, gameScores) => {
            dispatch(updateOverallScores(previousScores, gameScores));
        },
        removePhoneCallFromCalendar: phoneCallId => {
            dispatch(removePhoneCall(phoneCallId));
        },
        progressGame: () => {
            dispatch(progressTime('questions'));
        },
    };
};

const connected = connect(
    mapStateToProps,
    mapDispatchToProps,
)(QuestionsGameScreen);
export { connected as PMQsGameScreen };
